import * as types from '../types'

/**
 * 订单数据
 * package: 套餐相关
 * carts: 套餐购物车相关
 * logs: 某个套餐的配送日志列表
 * logDetail: 配送日志详情
 * @type {Object}
 */
const state = {
    package: {
        category: [],
        list: [],
        address: {},
    },
    carts: [],
    logs: [],
    logDetail: [],
    other: {
        id: '',
        date: ''
    }
}

const getters = {

}

const mutations = {
    /**
     * 动态删除套餐购物车数据
     * @type {[type]}
     */
    [types.AJAX_DEL_CARTS] (state, params) {
        if (state.carts.length == 0) return

        if (params.clean) {
            state.carts = []
        } else {
            let filter = state.carts.filter(item => params.id != item.id)
            state.carts = filter
        }
    },

    /**
     * 商品加入购物车
     * params {img,name,num, unit_price}
     * @type {[type]}
     */
    [types.AJAX_UPDATE_PACKAGE_CARTS] (state, params) {
        let num = 0
        state.carts.forEach((item) => {
            if (item.id == params.id) {
                item.num++
                num++
            }
        })

        if (num == 0) {
            state.carts.push(params)
        }
    },

    /**
     * 加载套餐商品数据
     * @type {[type]}
     */
    [types.INIT_PACKAGE_GOODS] (state, lists) {
        state.package.list = lists
    },

    /**
     * ajax 加载商品数据
     * @type {[type]}
     */
    [types.AJAX_UPDATE_PACKAGE_GOODS] (state, list) {
        state.package.list = state.package.list.concat(list)
    },

    /**
     * 初始化套餐数据
     * @type {[type]}
     */
    [types.INIT_PACKAGE_INFO] (state, params) {
        state.package.category = params.category
        state.package.address = params.address
    },

    /**
     * 加载套餐配送记录数据
     * @type {[type]}
     */
    [types.INIT_PACKAGE_LOGS] (state, arr) {
        state.logs = arr
    },

    /**
     * ajax  加载套餐配送记录数据
     * @type {[type]}
     */
    [types.AJAX_UPDATE_PACKAGE_LOGS] (state, arr) {
        state.logs = state.logs.concat(arr)
    },

    /**
     * 加载记录详情数据
     * @type {[type]}
     */
    [types.INIT_PACKAGE_LOG_DETAIL] (state, params) {
        state.logDetail = params
    },

    /**
     * 套餐购物车商品减少
     * @type {[type]}
     */
    [types.AJAX_PACKAGE_REDUCE] (state, id) {
        state.carts.forEach((item) => {
            if (item.id == id) {
                item.num -= 1
            }
        })
    },

    /**
     * 套餐购物车商品增加
     * @type {[type]}
     */
    [types.AJAX_PACKAGE_ADD] (state, id) {
        state.carts.forEach((item) => {
            if (item.id == id) {
                item.num = parseInt(item.num)

                item.num += 1
            }
        })
    },

    /**
     * 取消套餐订单
     * @type {[type]}
     */
    [types.AJAX_CANCEL_PACKAGE_ORDER] (state, id) {
        let arr = state.logs.filter((item) => item.id != id)

        state.logs = arr
    },

    /**
     * 编辑套餐数据加载
     * @type {Object}
     */
    [types.INIT_EDIT_PACKAGE] (state, params) {
        state.package.address = params.address
        state.carts = []
        state.other.id = params.info.p_item_id
        state.other.date = params.info.p_date

        if (params.carts.length > 0) {
            params.carts.forEach((item) => {
                let items = {}
                items.id = item.sku_id
                items.name = item.sku_name
                items.num = item.buy_nums
                items.thumb = item.thumb
                items.unit_amount = item.unit_amount
                items.unit_type = item.unit_type
                items.unit_price =  item.package_price

                state.carts.push(items)
            })
        }
    }
}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/package.js